import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { ReduxProvider } from 'app/src/components/ReduxProvider';
import { State } from 'app/gamma/src/modules/types';
import { getBoardsMenu } from 'app/gamma/src/selectors/boards';
import styles from './Surface.less';

const isAlwaysOpenBoardsMenu = (state: State): boolean => {
  const { alwaysOpenBoardsMenu } = getBoardsMenu(state);
  return alwaysOpenBoardsMenu;
};

const SurfaceStateless: React.FunctionComponent = ({ children }) => {
  const isPinnedBoardsMenu = useSelector(isAlwaysOpenBoardsMenu);

  return (
    <div
      id="surface"
      className={classNames(
        styles.surface,
        isPinnedBoardsMenu && styles.pinnedBoardsMenu,
      )}
    >
      {children}
    </div>
  );
};

export const Surface: React.FunctionComponent = ({ children }) => {
  return (
    <ReduxProvider>
      <SurfaceStateless>{children}</SurfaceStateless>
    </ReduxProvider>
  );
};
